const adminPanel = {
  adminPanel: {
    einAdmin: 'EIN管理者',
    einInstallerSetup: 'EINインストーラーのセットアップ',
    installerDataUpdate: 'インストーラー・データ更新',
    uploadFile: 'ファイルのアップロード',
    chooseFile: 'ファイルを選択',
    installerDataUpdateDescription: 'Enphase設置業者市場シェア、エグゼクティブスポンサー情報など',
    header: 'ヘッダーバーリンク',
    platinumTier: 'プラチナ階層',
    goldTier: 'ゴールド階層',
    silverTier: 'シルバー階層',
    same: '全階層共通',
    bannerDescription: 'バナー説明',
    bannerLink: 'バナーリンク',
    digitalAssets: 'デジタル資産',
    name: '名称',
    file: 'ファイル',
    access: '階層カテゴリーへのアクセス',
    action: 'アクション',
    all: 'すべて',
    platinum: 'プラチナ',
    gold: 'ゴールド',
    silver: 'シルバー',
    addDigital: 'デジタル資産の追加',
    productInformation: '製品情報',
    productName: '製品名',
    learnMoreLink: '詳細リンク',
    featureName: 'A/B機能名',
    featureType: '機能のタイプ',
    betaRelease: 'ベータ版リリース日',
    addProduct: '製品情報の追加',
    exclusiveUpdate: '独占アップデート・リンク',
    description: '説明',
    link: 'リンク',
    addLink: 'リンクの追加',
    one: '1.',
    two: '2.',
    installerList: '製品アクセス用設置業者リスト',
    usa: 'アメリカ',
    usa_pr: 'アメリカ - プエルトリコ',
    australia: 'オーストラリア',
    belgium: 'ベルギー',
    netherlands: 'オランダ',
    germany: 'ドイツ',
    india: 'インド',
    mexico: 'メキシコ',
    france: 'フランス',
    country: '国：',
    fileName: 'ファイル名',
    software_service: 'SOFTWARE_SERVICE',
    hardware_product: 'HARDWARE_PRODUCT',
    empty_file: 'ファイルは空です',
    invalidFileFormat: '無効なファイル形式',
    invalidFileHeader: '無効なファイルヘッダ',
    uploadFailed: 'ファイルのアップロードに失敗しました',
    invalidFile: '無効なファイル',
    errorDetail: {
      one: '%{errorCount} / %{count} 行が失敗しました。',
      other: '%{errorCount} / %{count} 行が失敗しました。'
    },
    viewError: 'エラー表示',
    errorListText: 'ファイルアップロードエラーリスト',
    companyId: '会社 ID',
    message: 'メッセージ',
    sampleFileName: 'サンプルファイル'
  }
};

export default adminPanel;
